import { render, staticRenderFns } from "./KButton.vue?vue&type=template&id=3e591c5b&scoped=true&"
import script from "./KButton.vue?vue&type=script&lang=js&"
export * from "./KButton.vue?vue&type=script&lang=js&"
import style0 from "./KButton.vue?vue&type=style&index=0&id=3e591c5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e591c5b",
  null
  
)

component.options.__file = "KButton.vue"
export default component.exports